import React from "react";
import Turnstile, { useTurnstile } from "react-turnstile";

/*
  SITEKEYDemo: 0x4AAAAAAAFlI6vF19bznFua
  SECRETDemo: 0x4AAAAAAAFlIyc0avrEUex4mGRvrF_01b0
  
  SITEKEYLive fmhud: 0x4AAAAAAAQUrpjn7BicYCxq
  SECRETLive fmhud: 0x4AAAAAAAQUrucxUF2WCuNqgAueHVsqCxQ

  SITEKEYLive Cviewsoft: 0x4AAAAAAARARY7v1b5qRrqX
  SECRETLive Cviewsoft: 0x4AAAAAAARARaRUFkjaI5i6auLAjxZXrGc
*/


const CAPTCHA = process.env.REACT_APP_CLOUDFLARE_SITEKEY;
const CAPTCHATurnStile = (props) => {
  //const turnstile = useTurnstile();
  //console.log("SITE KEY:", CAPTCHA);
  return (
    <>
      <Turnstile
        sitekey={CAPTCHA}
        onVerify={(token) => {
          fetch('/verify-turnstile', {
            method: "POST",
            body: JSON.stringify({ token }),
          }).then((response) => {
            //console.log("SITE KEY:", response); // there must be a responce. This will triger props.setReCaptcha(true) to true
            //if (!response.ok) turnstile.reset();
            props.setReCaptcha(true);
          });
        }}
      />
    </>
  );
};

export default CAPTCHATurnStile;
